import * as React from "react";
import { WidgetFrame } from "./WidgetFrame.jsx";
import { TextCard } from "../frame/TextCard.jsx";
//import * as cls from "./Progress.module.scss";
export { ProgressWidget };
/**
 * Виджет Личной студии, отображающая процесс загрузки или обработки данных.
 * @summary Виджет процесса загрузки и обработки данных.
 * @param {Object} props - Атрибуты элемента.
 * @param {"default"|"primary"|"danger"|"green"|"blue"|"yellow"|"burgundy"|"none"} [props.type=default] - Тип виджета.
 * @param {React.ReactNode} [props.title=Загрузка] - Заголовок секции.
 * @param {React.ReactNode} [props.message=Подождите, выполняется загрузка данных...] - Сообщение.
 * @returns {JSX.Element} Элемент JSX.
 * @see {@link WidgetFrame.jsx}
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
function ProgressWidget(
  {
    type = "default",
    title = "Загрузка",
    message = "Подождите, выполняется загрузка данных..."
  }) {
  return (
    <WidgetFrame type={type} icon="loading" title={title}>
      <TextCard type="primary">
        {message}
      </TextCard>
    </WidgetFrame>
  );
}
